import {z} from 'zod';

/**
 * Schema for editing document metadata (without file upload)
 * Used when updating existing documents
 *
 * Includes validation for:
 * - middlePrefix: Optional alphanumeric prefix
 * - documentNumber: Required for MANUAL mode, must be numeric
 * - startingRevision: Optional letter-based starting revision (e.g., "C", "D")
 */
export const documentMetadataSchema = z.object({
  name: z.string().min(1, 'Document name is required'),
  documentTypeId: z.string().uuid('Document type is required'),
  middlePrefix: z
    .string()
    .optional()
    .transform((value) => (value === '' ? undefined : value)),
  documentNumber: z
    .string()
    .optional()
    .refine(
      (value) => !value || /^\d+$/.test(value),
      'Document number must be numeric'
    )
    .transform((value) => (value === '' ? undefined : value)),
  startingRevision: z
    .string()
    .optional()
    .refine(
      (value) => !value || /^([A-Za-z]+|\d+)$/.test(value),
      'Starting revision must be letters (e.g., "C", "D") or numbers (e.g., "03", "004")'
    )
    .transform((value) => (value === '' ? undefined : value)),
  changelog: z.string().min(1, 'Revision notes are required'),
  summary: z.string().optional(),
  fieldValues: z
    .record(z.union([z.string(), z.array(z.string()), z.null()]))
    .optional(),
});

export type DocumentMetadataFormData = z.infer<typeof documentMetadataSchema>;
